import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_SASS from "../../assets/img/skills/sass-1.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";

import L_SPRING_BOOT from "../../assets/img/skills/icons8-spring-boot.svg";
import L_MICROSERVICES from "../../assets/img/skills/icons8-architecture-34.png";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_POSTGRESQL from "../../assets/img/skills/icons8-postgresql.svg";

import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_HEROKU from "../../assets/img/skills/heroku.svg";

import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";

import L_PYTHON from "../../assets/img/skills/python.svg";
import L_JAVA from "../../assets/img/skills/icons8-java.svg";

import L_FIREBASE from "../../assets/img/skills/firebase.svg";
import L_AWS from "../../assets/img/skills/icons8-aws.svg";
import L_AZURE from "../../assets/img/skills/icons8-azure.svg";

import L_MAVEN from "../../assets/img/skills/icons8-maven-ios-50.png";
import L_DOCKER from "../../assets/img/skills/icons8-docker.svg";
import L_JENKINS from "../../assets/img/skills/icons8-jenkins.svg";
import L_KUBERNATES from "../../assets/img/skills/icons8-kubernetes.svg";
import L_KAFKA from "../../assets/img/skills/kafka-icon.svg";

export const skills = {
  programmingLanguages: [
    {
      link: "https://docs.oracle.com/en/java/",
      imgAltText: "Java",
      imgSrc: L_JAVA,
      skillName: "Java",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },

  ],
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_SASS,
      skillName: "Sass",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
  ],

  backend: [
    {
      link: "https://docs.spring.io/spring-boot/index.html",
      imgAltText: "Spring Boot",
      imgSrc: L_SPRING_BOOT,
      skillName: "Spring Boot",
    },
    {
      link: "https://spring.io/blog/2015/07/14/microservices-with-spring",
      imgAltText: "Microservices",
      imgSrc: L_MICROSERVICES,
      skillName: "Microservices",
    },
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },

  ],
  cloudPlatforms: [
    {
      link: "https://aws.amazon.com/console/",
      imgAltText: "AWS",
      imgSrc: L_AWS,
      skillName: "AWS",
    },
    {
      link: "https://learn.microsoft.com/en-us/azure/?product=popular",
      imgAltText: "Azure",
      imgSrc: L_AZURE,
      skillName: "Azure",
    },

  ],

  toolsAndTechnologies: [
    {
      link: "https://maven.apache.org/guides/index.html",
      imgAltText: "Maven",
      imgSrc: L_MAVEN,
      skillName: "Maven",
    },
    {
      link: "https://kafka.apache.org/documentation/",
      imgAltText: "Kafka",
      imgSrc: L_KAFKA,
      skillName: "Apache Kafka",
    },
    {
      link: "https://docs.docker.com/",
      imgAltText: "Docker",
      imgSrc: L_DOCKER,
      skillName: "Docker",
    },
    {
      link: "https://www.jenkins.io/doc/",
      imgAltText: "Jenkins",
      imgSrc: L_JENKINS,
      skillName: "Jenkins",
    },
    {
      link: "https://kubernetes.io/docs/home/",
      imgAltText: "Kubernetes",
      imgSrc: L_KUBERNATES,
      skillName: "Kubernetes",
    },
  ],

  databases: [
    {
      link: "https://www.postgresql.org/docs/",
      imgAltText: "PostgreSQL",
      imgSrc: L_POSTGRESQL,
      skillName: "PostgreSQL",
    },
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },

    {
      link: "https://dev.mysql.com/doc/",
      imgAltText: "My-SQL",
      imgSrc: "https://download.logo.wine/logo/MySQL/MySQL-Logo.wine.png",
      skillName: "My SQL",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
};
